"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TerritorySelection;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TerritorySelectionModule = _interopRequireDefault(require("./TerritorySelection.module.scss"));

var _rog = _interopRequireDefault(require("./data/rog"));

var _common = require("../../common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imgUrl = "https://cdn.fhxrestoration.com/todo/images/mapsTODO/main_OLD.jpg";
var width = "1664px";
var height = "2560px";

function TerritorySelection(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  return /*#__PURE__*/_react.default.createElement(_common.BorderedBox, {
    type: "PROMPT_WINDOW",
    className: (0, _classnames.default)(_TerritorySelectionModule.default.selector, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      backgroundImage: "url(".concat(imgUrl, ")")
    }
  }, /*#__PURE__*/_react.default.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: width,
      height: height
    }
  }, /*#__PURE__*/_react.default.createElement("polygon", {
    points: _rog.default.map(function (point) {
      return "".concat(point[0], " ").concat(point[1]);
    }).join(",")
  }))));
}